export const TPA_PAGE_ID_BLOG = 'blog';
export const TPA_PAGE_ID_POST = 'post';
